import { render } from "./AcBottomNavigation.vue?vue&type=template&id=06dc2bee&scoped=true&ts=true"
import script from "./AcBottomNavigation.vue?vue&type=script&lang=ts"
export * from "./AcBottomNavigation.vue?vue&type=script&lang=ts"

import "./AcBottomNavigation.vue?vue&type=style&index=0&id=06dc2bee&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dc2bee"]])

export default __exports__